<template>
  <ContentSection class="w-auto">
    <!-- TITLE & TEXT -->
    <HeadingAndText :heading="data.heading" :text="data.text" />

    <!-- SLIDER -->

    <div class="relative">
      <Swiper
        :modules="[Navigation]"
        :slides-per-view="1"
        :allow-touch-move="true"
        :navigation="true"

        class="customs-swiper-style"
        @slide-change="onSlideChange"
      >
        <SwiperSlide
          v-for="slide in data.slides"
          :key="slide.id"
        >
          <SliderSlide :key="key" :data="slide" @open-slider-full-screen="showSliderFullScreen = true" />
        </SwiperSlide>
      </Swiper>

      <!-- Pagination -->
      <div class="absolute bottom-4 right-4 z-10 text-white">
        {{ activeIndex }} / {{ data.slides?.length }}
      </div>
    </div>

    <!-- FULL SCREEN -->
    <Transition name="fade">
      <SliderGallery
        v-if="showSliderFullScreen"
        :images="data.slides
          .filter(slide => slide.image || slide.entry?.image)
          .map(slide => slide.image || slide.entry?.image)"
        :active-index="activeIndex"
        :open="showSliderFullScreen"
        @close="showSliderFullScreen = false"
      />
    </Transition>
  </ContentSection>
</template>

<script setup lang="ts">
import type { MainComponentsAccordionFragment } from '#gql'
import { Navigation } from 'swiper/modules'
import 'swiper/css/navigation'

const props = defineProps<{
  data: Enforce<MainComponentsAccordionFragment>
  isOpen?: boolean
}>()

const showSliderFullScreen = ref(false)

const activeIndex = ref(1)

function onSlideChange(swiper: any) {
  activeIndex.value = swiper.activeIndex + 1
}

// If the Slider is in the Accordion, we need to rerender the slides when the accordion is opened to fix image aspects (workaround).
const key = ref(0)
watch(() => props.isOpen, (value) => {
  if (value && key.value === 0) {
    key.value++
  }
})
</script>

<style>
.customs-swiper-style {
  .swiper-slide {
    height: auto;
  }
  .swiper-button-prev,
  .swiper-button-next {
    color: white;
  }
}
</style>
